// Kiri Katana: odsłanianie elementów przy scrollu (IntersectionObserver, bez bibliotek).
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  if (window.Shopify && window.Shopify.designMode) return; // w edytorze motywu wszystko widoczne od razu
  // To, co już widać na pierwszym ekranie, zostaje widoczne od razu (bez mignięcia i bez opóźnienia).
  const naEkranie = () =>
    document.querySelectorAll('[data-reveal]').forEach((el) => {
      if (el.getBoundingClientRect().top < innerHeight) el.classList.add('is-revealed');
    });
  naEkranie();
  document.documentElement.classList.add('kiri-js');
  const io = new IntersectionObserver(
    (entries) =>
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        }
      }),
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );
  const scan = () =>
    document.querySelectorAll('[data-reveal]').forEach((el, i) => {
      if (el.classList.contains('is-revealed')) return;
      el.style.transitionDelay = `${Math.min(i % 4, 3) * 70}ms`;
      io.observe(el);
    });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  addEventListener('beforeprint', () => document.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-revealed')));
})();

// Kiri Katana: strzałki i kropki pod poziomymi ścieżkami (.kiri-track). Jedna kropka = jedna „strona” pełnych kart.
(() => {
  const arrow = (dir) =>
    `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${dir === 'prev' ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6'}"/></svg>`;

  const setup = (scroller) => {
    if (scroller.dataset.kiriPager) return;
    scroller.dataset.kiriPager = '1';
    const pager = document.createElement('div');
    pager.className = 'kiri-pager';
    pager.innerHTML = `<button type="button" class="kiri-pager__arrow" data-dir="prev" aria-label="Poprzednie">${arrow('prev')}</button><div class="kiri-pager__dots"></div><button type="button" class="kiri-pager__arrow" data-dir="next" aria-label="Następne">${arrow('next')}</button>`;
    scroller.after(pager);
    const dotsEl = pager.querySelector('.kiri-pager__dots');
    const [prev, next] = pager.querySelectorAll('.kiri-pager__arrow');
    let state = { count: 1, starts: [0], list: null };

    const measure = () => {
      const list = [...scroller.children].filter((el) => el.offsetWidth > 0);
      if (!list.length) return;
      const step = list.length > 1 ? list[1].offsetLeft - list[0].offsetLeft : list[0].offsetWidth;
      const per = Math.max(1, Math.round((scroller.clientWidth + (step - list[0].offsetWidth)) / step));
      const count = Math.max(1, Math.ceil(list.length / per));
      const starts = [];
      for (let i = 0; i < count; i++) starts.push(Math.min(i * per, list.length - per));
      list.forEach((el, i) => el.toggleAttribute('data-snap', starts.includes(i)));
      state = { count, starts, list };
      pager.hidden = count < 2;
      dotsEl.innerHTML = starts
        .map((_, i) => `<button type="button" class="kiri-pager__dot" aria-label="Strona ${i + 1} z ${count}"></button>`)
        .join('');
      update();
    };

    const current = () => {
      const { starts, list } = state;
      if (!list) return 0;
      if (scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 4) return starts.length - 1;
      const base = list[0].offsetLeft;
      let best = 0;
      starts.forEach((s, i) => {
        if (Math.abs(list[s].offsetLeft - base - scroller.scrollLeft) < Math.abs(list[starts[best]].offsetLeft - base - scroller.scrollLeft)) best = i;
      });
      return best;
    };

    const update = () => {
      const page = current();
      dotsEl.querySelectorAll('.kiri-pager__dot').forEach((d, i) => d.setAttribute('aria-current', String(i === page)));
      prev.disabled = page === 0;
      next.disabled = page >= state.count - 1;
    };

    const go = (target) => {
      const { starts, list } = state;
      if (!list) return;
      const p = Math.max(0, Math.min(target, starts.length - 1));
      scroller.scrollTo({ left: list[starts[p]].offsetLeft - list[0].offsetLeft, behavior: 'smooth' });
    };

    prev.addEventListener('click', () => go(current() - 1));
    next.addEventListener('click', () => go(current() + 1));
    dotsEl.addEventListener('click', (e) => {
      const dot = e.target.closest('.kiri-pager__dot');
      if (dot) go([...dotsEl.children].indexOf(dot));
    });
    let raf;
    scroller.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    new ResizeObserver(measure).observe(scroller);
    measure();
  };

  const scan = () => document.querySelectorAll('.kiri-track').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
